var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 126,
    viewBox: "0 0 416 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.282 18.7635C254.541 -5.76982 128.129 -1.61926 63.2416 19.8486C33.6901 29.6258 -20.8019 57.9555 12.3567 84.7023C18.2051 89.42 25.314 93.2526 32.669 96.569C113.615 133.066 226.512 129.349 313.385 107.511C326.341 104.254 339.09 100.388 350.82 95.1328C359.593 91.2026 368.074 86.3312 374.906 80.6464C394.904 64.0041 389.68 47.2558 368.163 33.1468C343.217 16.7884 309.103 11.719 276.915 8.94271C248.768 6.5151 220.656 6.04893 192.376 7.03971C139.339 8.89759 78.2179 11.8538 33.7355 34.2187C14.3068 43.9874 -6.56685 64.8614 10.087 81.7559C28.1337 100.063 70.6856 105.991 99.3064 109.854C176.517 120.276 298.684 115.108 369.013 87.7595C376.597 84.8102 384.28 82.0617 391.064 78.1835C396.425 75.119 401.557 71.6248 406.01 67.8433C437.564 41.0439 367.153 24.1937 342.321 21.3C264.203 12.1968 148.584 -0.940081 76.6418 23.2761",
    stroke: "#00BA80",
    strokeWidth: 3,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.84f25085a223aff4509b41ea24e639aa.svg";
export { ForwardRef as ReactComponent };